import React, { useEffect, useMemo, useRef, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation, useNavigate } from 'react-router-dom';

import { Spin } from 'antd';
import moment from 'moment';

import AccountNav from '../../components/AccountNav/AccountNav';
import AccountNavMobile from '../../components/AccountNavMobile/AccountNavMobile';
import PortfolioBarchart from '../../components/Charts/PortfolioBarchart';
import ListingAgreement from '../../components/ListingAgreement/ListingAgreement';
import MarketFooter from '../../components/MarketFooter/MarketFooter';
import PinDrawerWithoutButton from '../../components/PinDrawerWithoutButton/PinDrawerWithoutButton';
import PinModalWithoutButton from '../../components/PinModalWithoutButton/PinModalWithoutButton';
import PortfolioCard from '../../components/PortfolioCard/PortfolioCard';
import PortfolioTable from '../../components/PortfolioTable/PortfolioTable';
import PortfolioTableMobile from '../../components/PortfolioTableMobile/PortfolioTableMobile';
import TradeDrawer from '../PropertyListing/TradeDrawer';
import TradeModal from '../PropertyListing/TradeModal';
import EditOrderDrawer from './EditOrderDrawer';
import EditOrderModal from './EditOrderModal';

import { NextArrow } from '../../assets/icons';

import useGetUserProfile from '../../Hooks/useGetUserProfile';
import useMediaQuery from '../../Hooks/useMediaQuery';
import useQuickBuySecondary from '../../Hooks/useQuickBuySecondary';
import { Images } from '../../config/images';
import { fetchOpenOrderData, fetchPortfolioChart } from '../../services/PortfolioApi/portfolioApi';
import { getDateFormat } from '../../utils';
import { DATE_FORMAT, formatDate } from '../../utils/dateFormat.helper';
import { toastNotify } from '../../utils/toastNotify';
import { getUsCurrencyFormat, getUsCurrencyFormatWithoutDecimal, getUsPercentageFormat } from '../../utils/usCurrencyFormatter';

import './Portfolio.scss';

const TIMELINE_LABELS = ['7D', '1M', '6M', '1Y', 'YTD', 'MAX'];

const INTERVALS = {
  '7D': 0,
  '1M': 6,
  '6M': 0,
  '1Y': 0,
  YTD: 0,
  MAX: 0,
};
const Portfolio = (props) => {
  const screenMD = useMediaQuery('(min-width: 1000px)');
  const [openQuickBuy, setOpenQuickBuy] = useState();
  const [quickBuyPropertyData, setQuickBuyPropertyData] = useState({});
  const [isShowFullDate, setIsShowFullDate] = useState(true);
  const { data: propertyDetails, loading: propertyLoading } = useSelector((state) => state.propertyDetails);
  const userProfileData = useSelector((state) => state.userData.userData);
  const dispatch = useDispatch();
  const quickBuySecondaryOptions = useQuickBuySecondary(setOpenQuickBuy, quickBuyPropertyData, {});
  const [storeOrderValue, setStoreOrderValue] = useState();
  const orderRef = useRef();
  const SEONDARYOBJ = {
    propertyId: 0,
    propertyName: '',
    label: '',
    cityName: '',
    cityId: 0,
    stateId: 0,
    stateName: '',
    propertyCreatedAt: '',
    images: {},
    propertyType: '',
    dividendYield: 0.0,
    lastTradedPrice: 0,
    allTime: 0.0,
    bids: 0,
    asks: 0,
    likedByLoggedInUser: null,
  };
  const assetTableColumns = [
    {
      title: 'Property',
      width: 100,
      dataIndex: 'propertyName',
      key: 'name',
      fixed: 'left',
      render: (val, record) => {
        return (
          <div className='title'>
            {val}
            <Link to={`/portfolio/assets/${record?.propertyId}`}>
              {' '}
              <NextArrow className='cursor-pointer' color='#1A1519' size={10} />
            </Link>
          </div>
        );
      },
    },
    {
      title: 'Total value',
      dataIndex: 'totalValue',
      key: '1',
      width: 50,
      render: (val) => `$${getUsCurrencyFormat(Number(val) || 0)}`,
    },
    {
      title: 'Total gain',
      dataIndex: 'totalGain',
      key: '2',
      width: 50,
      render: (val) =>
        Number(val) === 0 ? (
          <span>$0</span>
        ) : (
          <span className={Number(val) > 0 ? 'text-success' : 'text-error'}>
            {Number(val) > 0 ? '+' : '-'} ${getUsCurrencyFormat(Number(val) > 0 ? Number(val) : -Number(val) || 0)}
          </span>
        ),
    },
    {
      title: 'Quantity',
      dataIndex: 'quantity',
      key: '3',
      width: 50,
      render: (val) => `${getUsCurrencyFormatWithoutDecimal(Number(val))}`,
    },
    {
      title: 'Last price',
      dataIndex: 'lastPrice',
      key: '5',
      width: 50,
      render: (val) => `$${getUsCurrencyFormat(Number(val || 0))}`,
    },
    {
      title: 'Best bid',
      dataIndex: 'highestBid',
      key: '4',
      width: 50,
      render: (val) => `$${getUsCurrencyFormat(Number(val) || 0)}`,
    },
    {
      title: 'Best ask',
      dataIndex: 'lowestAsk',
      key: '4',
      width: 50,
      render: (val) => `$${getUsCurrencyFormat(Number(val) || 0)}`,
    },
    {
      title: ' ',
      key: 'operation',
      width: 50,
      render: (val) => (
        <span
          className='fw-600 text-copper cursor-pointer'
          onClick={() => {
            setQuickBuyPropertyData(val);
            setOpenQuickBuy('StepOne');
          }}
        >
          Trade
        </span>
      ),
    },
  ];
  const orderTableColumns = [
    {
      title: 'Property',
      width: 100,
      dataIndex: 'property',
      key: 'name',
      fixed: 'left',
    },
    {
      title: 'Date',
      dataIndex: 'createdAt',
      key: 'createdAt',
      width: 50,
      render: (val) => formatDate(val, DATE_FORMAT.DATE_FORMAT_SHORT),
    },
    {
      title: 'Type',
      dataIndex: 'type',
      key: '1',
      width: 50,
    },
    {
      title: 'Total purchase',
      dataIndex: 'totalPrice',
      key: '2',
      width: 50,
      render: (val) => `$${getUsCurrencyFormat(val)}`,
    },
    {
      title: 'Quantity',
      dataIndex: 'quantity',
      key: '3',
      width: 50,
      render: (val) => `${getUsCurrencyFormatWithoutDecimal(val)}`,
    },
    {
      title: 'Order price',
      dataIndex: 'orderPrice',
      key: '4',
      width: 50,
      render: (val) => `$${getUsCurrencyFormat(val)}`,
    },
    {
      title: 'Last price',
      dataIndex: 'lastPrice',
      key: '5',
      width: 50,
      render: (val) => `$${getUsCurrencyFormat(val)}`,
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: '6',
      width: 50,
    },
    {
      title: ' ',
      key: 'operation',
      width: 50,
      render: (val) => {
        return (
          <>
            {val?.type === 'IPO' ? (
              <span
                className='fw-600 text-copper cursor-pointer'
                onClick={() => {
                  quickBuySecondaryOptions?.handleFeatchOpenOrderDetail(val);
                }}
              >
                View
              </span>
            ) : (
              <span
                className='fw-600 text-copper cursor-pointer'
                onClick={() => {
                  quickBuySecondaryOptions?.setStoreOrderValue(val);
                  quickBuySecondaryOptions?.setOpenPinModal(true);
                }}
              >
                Edit
              </span>
            )}
          </>
        );
      },
    },
  ];

  const openOrdersRef = useRef(null);
  const location = useLocation();

  const handleOnScrollIntoView = () => {
    openOrdersRef?.current?.scrollIntoView();
  };
  useEffect(() => {
    if (location.hash === '#open-orders') {
      handleOnScrollIntoView();
    }
  }, [location]);

  const screenSm = useMediaQuery('(max-width: 639px)');
  const [loading, setLoading] = useState(true);
  const [tableLoader, setTableLoader] = useState(false);
  const [openOrdertableData, setOpenOrderTableData] = useState({});
  const [selectedTimeline, setSelectedTimeline] = useState('1M');
  const [isFetchingChart, setIsFetchingChart] = useState(false);
  const [timelineChartData, setTimelineChartData] = useState(null);
  const [timelineLabels, setTimelineLabels] = useState(TIMELINE_LABELS);
  const [assetsData, setAssetsData] = useState([]);
  const [portfolioAge, setPortfolioAge] = useState(0);
  const [portfolioStartDate, setPortfolioStartDate] = useState('');
  const cardRef = useRef(null);

  useGetUserProfile();

  const handleSelectTimeline = async (label) => {
    try {
      setSelectedTimeline(label);
      setIsFetchingChart(true);
      const data = await fetchPortfolioChart(label);
      setTimelineChartData(data?.data);
    } catch (err) {
      toastNotify('error', err?.response?.data?.message || 'Failed getting chart data');
    } finally {
      setIsFetchingChart(false);
    }
  };
  const fetchOpenOrderTableData = async () => {
    setTableLoader(true);
    try {
      const openOrderResp = await fetchOpenOrderData({ page: 1, perPage: 200 });
      const openOrderResponse = openOrderResp.data;
      let openOrder = {
        ...openOrderResponse,
        openOrders: openOrderResponse?.openOrders,
      };
      if (!openOrderResp.isError) {
        setOpenOrderTableData({ ...openOrder });
      } else {
        toastNotify('error', openOrderResp?.message);
      }
    } catch (error) {
      const { response } = error;
      toastNotify('error', response?.data?.message);
    } finally {
      setLoading(false);
      setTableLoader(false);
    }
  };

  const fetchPortfolioData = async () => {
    const cardsData = await cardRef?.current?.fetchCardData();
    const assetData = cardsData?.myAssets || [];
    setAssetsData(assetData);
    const startDate = cardsData?.startDate;
    const ageInMonths = moment().diff(moment(startDate || new Date()), 'months');
    setPortfolioStartDate(startDate);
    setPortfolioAge(ageInMonths);
    if (ageInMonths < 6) {
      setTimelineLabels((state) => state.filter((x) => x !== '6M' && x !== '1Y'));
    }
    handleSelectTimeline('1M');
  };
  const handleOpenEditDrawer = (value) => {
    if (value?.type === 'IPO') {
      quickBuySecondaryOptions?.handleFeatchOpenOrderDetail(value);
    } else {
      quickBuySecondaryOptions?.setStoreOrderValue(value);
      quickBuySecondaryOptions?.setOpenPinModal(true);
    }
  };
  const generateDummyDataBetweenDates = (start, end = moment(), diff = 'day') => {
    try {
      const data = [];
      for (let i = moment(start); i.isBefore(moment(end)); i.add(1, diff)) {
        data.push({
          date: i.toISOString(),
          total: 0,
          sharesTotal: 0,
          dividendTotal: 0,
        });
      }
      return data;
    } catch (error) {
      return [];
    }
  };

  const generateDummyDataBetweenMonths = (start, end = moment(), diff = 'day') => {
    const startMonth = moment(start).month();
    const endMonth = moment(end).month();
    const durationInDays = moment(end).diff(start, 'days');
    if (durationInDays <= 31) {
      // If the difference between start and end is less than or equal to 31 days, generate day-wise data
      return generateDummyDataBetweenDates(start, end, 'day');
    }
    // Generate month-wise data
    const data = [];
    let tempDate = moment(start);
    try {
      for (let i = startMonth; i <= endMonth; i++) {
        const monthEndDate = tempDate.endOf('month').toDate();
        const lastDayOfMonth = moment(monthEndDate).date();
        for (let j = tempDate.date(); j <= lastDayOfMonth; j++) {
          data.push({
            date: tempDate.toISOString(),
            total: 0,
            sharesTotal: 0,
            dividendTotal: 0,
          });
          tempDate.add(1, 'day');
        }
      }
    } catch (error) {
      console.error('Error generating data:', error);
    }
    return data;
  };
  const navigate = useNavigate();

  useEffect(() => {
    fetchPortfolioData();
    fetchOpenOrderTableData();
  }, []);

  const chartData = useMemo(() => {
    if (isFetchingChart) return [];
    let fullDateOptions = {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
    };
    switch (selectedTimeline) {
      case '7D':
        setIsShowFullDate(true);
        return (
          generateDummyDataBetweenDates(timelineChartData?.startDate, timelineChartData?.endDate, 'days')?.map((x) => {
            const currentDateDataFromAPI = timelineChartData?.chartData?.find((apiData) => moment(apiData.date).isSame(x.date, 'day'));
            if (currentDateDataFromAPI) {
              return {
                ...currentDateDataFromAPI,
                fullDate: getDateFormat({
                  date: new Date(x.date),
                  options: fullDateOptions,
                }),
                date: getDateFormat({
                  date: new Date(x.date),
                  options: {
                    weekday: 'short',
                  },
                }),
              };
            }
            return {
              ...x,
              fullDate: getDateFormat({
                date: new Date(x.date),
                options: fullDateOptions,
              }),
              date: getDateFormat({
                date: new Date(x.date),
                options: {
                  weekday: 'short',
                },
              }),
            };
          }) || []
        );
      case '1M':
        setIsShowFullDate(true);
        return (
          generateDummyDataBetweenDates(timelineChartData?.startDate, timelineChartData?.endDate, 'days')?.map((x) => {
            const currentDateDataFromAPI = timelineChartData?.chartData?.find((apiData) => moment(apiData.date).isSame(x.date, 'day'));
            if (currentDateDataFromAPI) {
              return {
                ...currentDateDataFromAPI,
                fullDate: getDateFormat({
                  date: new Date(x.date),
                  options: fullDateOptions,
                }),
                date: getDateFormat({
                  date: new Date(x.date),
                  options: {
                    month: 'short',
                    day: 'numeric',
                  },
                }),
              };
            }
            return {
              ...x,
              fullDate: getDateFormat({
                date: new Date(x.date),
                options: fullDateOptions,
              }),
              date: getDateFormat({
                date: new Date(x.date),
                options: {
                  month: 'short',
                  day: 'numeric',
                },
              }),
            };
          }) || []
        );
      case '6M':
        setIsShowFullDate(false);
        return (
          generateDummyDataBetweenDates(timelineChartData?.startDate, timelineChartData?.endDate, 'months')?.map((x) => {
            const currentDateDataFromAPI = timelineChartData?.chartData?.find((apiData) => moment(apiData.date).isSame(x.date, 'month'));
            if (currentDateDataFromAPI) {
              return {
                ...currentDateDataFromAPI,
                fullDate: getDateFormat({
                  date: new Date(x.date),
                  options: fullDateOptions,
                }),
                date: getDateFormat({
                  date: new Date(x.date),
                  options: {
                    month: 'short',
                  },
                }),
              };
            }
            return {
              ...x,
              fullDate: getDateFormat({
                date: new Date(x.date),
                options: fullDateOptions,
              }),
              date: getDateFormat({
                date: new Date(x.date),
                options: {
                  month: 'short',
                },
              }),
            };
          }) || []
        );

      case 'YTD':
        setIsShowFullDate(false);
        // let YTDData =
        // generateDummyDataBetweenDates(timelineChartData?.startDate, 'months')
        // YTDData[YTDData.length - 1].date = timelineChartData.chartData[timelineChartData.chartData.length-1]?.date;
        return (
          generateDummyDataBetweenDates(timelineChartData?.startDate, moment(), 'months').map((x) => {
            const currentDateDataFromAPI = timelineChartData?.chartData?.find((apiData) => moment(apiData.date).isSame(x.date, 'month'));
            if (currentDateDataFromAPI) {
              return {
                ...currentDateDataFromAPI,
                fullDate: getDateFormat({
                  date: new Date(x.date),
                  options: fullDateOptions,
                }),
                date: getDateFormat({
                  date: new Date(x.date),
                  options: { month: 'short', year: 'numeric' },
                }),
              };
            }
            return {
              ...x,
              fullDate: getDateFormat({
                date: new Date(x.date),
                options: fullDateOptions,
              }),
              date: getDateFormat({
                date: new Date(x.date),
                options: {
                  month: 'short',
                  year: 'numeric',
                },
              }),
            };
          }) || []
        );
      case '1Y':
        return (
          generateDummyDataBetweenDates(timelineChartData?.startDate, timelineChartData?.endDate, 'months')?.map((x) => {
            const currentDateDataFromAPI = timelineChartData?.chartData?.find((apiData) => moment(apiData.date).isSame(x.date, 'month'));
            if (currentDateDataFromAPI) {
              return {
                ...currentDateDataFromAPI,
                fullDate: getDateFormat({
                  date: new Date(x.date),
                  options: fullDateOptions,
                }),
                date: getDateFormat({
                  date: new Date(x.date),
                  options: {
                    month: 'short',
                  },
                }),
              };
            }
            return {
              ...x,
              fullDate: getDateFormat({
                date: new Date(x.date),
                options: fullDateOptions,
              }),
              date: getDateFormat({
                date: new Date(x.date),
                options: {
                  month: 'short',
                },
              }),
            };
          }) || []
        );
      case 'MAX':
        // This depends on portfolio age
        let options = {
          month: 'short',
          day: 'numeric',
        };
        setIsShowFullDate(true);
        let diff = 'days';
        if (portfolioAge >= 1) {
          setIsShowFullDate(false);
          options = {
            month: 'short',
            year: 'numeric',
          };
          diff = 'months';
        }
        let MAXData = generateDummyDataBetweenMonths(portfolioStartDate, timelineChartData.endDate, diff);

        if (MAXData.length) {
          MAXData[MAXData.length - 1].date = timelineChartData.chartData[timelineChartData.chartData.length - 1]?.date;
        } else {
          MAXData.push({
            date: timelineChartData.endDate,
            total: 0,
            sharesTotal: 0,
            dividendTotal: 0,
          });
        }

        return (
          MAXData?.map((x) => {
            const currentDateDataFromAPI = timelineChartData?.chartData?.find((apiData) => moment(apiData.date).isSame(x.date, diff));
            if (currentDateDataFromAPI) {
              return {
                ...currentDateDataFromAPI,
                fullDate: getDateFormat({
                  date: new Date(x.date),
                  options: fullDateOptions,
                }),
                date: getDateFormat({
                  date: new Date(x.date),
                  options,
                }),
              };
            }
            return {
              ...x,
              fullDate: getDateFormat({
                date: new Date(x.date),
                options: fullDateOptions,
              }),
              date: getDateFormat({
                date: new Date(x.date),
                options,
              }),
            };
          }) || []
        );

      default:
        break;
    }
  }, [selectedTimeline, isFetchingChart, timelineChartData, portfolioAge]);

  const getPortfolioBarchartInterval = () => {
    if (selectedTimeline === 'MAX') {
      if (portfolioAge < 15) {
        return 0; // Set interval to 0 if the portfolio age is less than 15 days
      } else if (portfolioAge > 1) {
        return parseInt(chartData.length / 6); // Set interval to 1/6th of the data length if the portfolio age is greater than 1 year
      } else {
        return 1; // Set interval to 1 day if the portfolio age is greater than 15 days and less than 1 year
      }
    } else {
      return INTERVALS[selectedTimeline]; // Use the regular interval for other timelines
    }
  };
  const portfolioBarchartInterval = getPortfolioBarchartInterval();

  const qucikBuyPropertyDataObject = useMemo(() => {
    return {
      ...SEONDARYOBJ,
      propertyId: propertyDetails?.data?.propertyId,
      propertyName: propertyDetails?.data?.name,
      label: propertyDetails?.data?.tag,
      cityName: propertyDetails?.data?.city,
      cityId: 0,
      stateId: 0,
      stateName: propertyDetails?.data?.state,
      propertyCreatedAt: '',
      images: propertyDetails?.data?.images,
      propertyType: propertyDetails?.data?.propertyTypeName,
      dividendYield: propertyDetails?.data?.tenantStatus?.dividendYield,
      lastTradedPrice: Number(propertyDetails?.data?.lastPrice),
      allTime: getUsPercentageFormat(
        (100 * (Number(propertyDetails?.data?.lastPrice) - Number(propertyDetails?.data?.finance?.perSharePrice))) /
          Number(propertyDetails?.data?.finance?.perSharePrice) || 0
      ),
      bids: propertyDetails?.data?.totalBids,
      asks: propertyDetails?.data?.totalAsks,
      likedByLoggedInUser: null,
    };
  }, [propertyDetails]);

  return (
    <>
      <div className='portfolio'>
        <div className='sticky-nav'>
          <AccountNav />
        </div>
        <div className='sticky-nav'>
          <AccountNavMobile />
        </div>
        <div className='portfolio__head'>
          <div className='container-fluid'>
            <h3>Portfolio</h3>
          </div>
        </div>

        <Spin spinning={loading}>
          <PortfolioCard setLoading={setLoading} ref={cardRef} isInvested={Boolean(openOrdertableData?.openOrders?.length || assetsData?.length)} />

          {openOrdertableData?.openOrders?.length || assetsData?.length ? (
            <div className='container-fluid text-center graph'>
              <p className='fz-18 fw-600 mb-28 text-left'>Portfolio Performance</p>
              <div className='timeline'>
                {React.Children.toArray(
                  timelineLabels.map((label) => {
                    return (
                      <span
                        onClick={() => {
                          handleSelectTimeline(label);
                        }}
                        className={`timeline__item ${label === selectedTimeline ? 'active' : ''}`}
                      >
                        {label}
                      </span>
                    );
                  })
                )}
              </div>
            </div>
          ) : (
            <>
              {!loading ? (
                <>
                  <div className='container-fluid'>
                    <hr className='hr my-56' />
                  </div>
                  <div className='zero-state text-center'>
                    <div>
                      <img src={Images.portfoliozero} alt='' className='mb-32' />
                    </div>
                    <p className='fw-700 fz-20 mb-16'>Start potentially building your wealth. One brick at a time.</p>
                    <p className='mb-40'>
                      Once you invest in a series on the Realbricks marketplace, you will see the series assets associated with your shares.
                    </p>
                    <Link to='/' className='px-47 py-10 bg-copper text-white fw-600 radius-4 fz-16 btn-link'>
                      Browse properties
                    </Link>
                  </div>
                </>
              ) : (
                <></>
              )}
            </>
          )}
        </Spin>
        {openOrdertableData?.openOrders?.length || assetsData?.length ? (
          <>
            <div className='container-fluid'>
              <Spin spinning={isFetchingChart} wrapperClassName='graph__spin'>
                <PortfolioBarchart data={chartData} interval={portfolioBarchartInterval} isShowFullDate={isShowFullDate} />
              </Spin>
            </div>

            <div ref={openOrdersRef}></div>
            {screenSm ? (
              <PortfolioTableMobile
                PortfolioTableMobileHead='Open orders'
                tableData={openOrdertableData.openOrders}
                isOrder={true}
                onOpen={(value) => handleOpenEditDrawer(value)}
                count={openOrdertableData?.count || 0}
                handleOnScrollIntoView={handleOnScrollIntoView}
              />
            ) : (
              <PortfolioTable
                PortfolioTableHead='Open Orders'
                tableData={openOrdertableData.openOrders}
                tableLoader={tableLoader}
                count={openOrdertableData?.count || 0}
                columns={orderTableColumns}
                handleOnScrollIntoView={handleOnScrollIntoView}
                isOrder={true}
              />
            )}
            <div className='container-fluid text-center'>
              <hr className='mb-10' />
            </div>
            {assetsData?.length ? (
              screenSm ? (
                <PortfolioTableMobile
                  PortfolioTableMobileHead='My Assets'
                  tableData={assetsData}
                  count={assetsData?.length}
                  onOpen={(order) => {
                    navigate(`/portfolio/assets/${order?.propertyId}`);
                  }}
                />
              ) : (
                <PortfolioTable count={assetsData?.length} PortfolioTableHead='My Assets' tableData={assetsData} columns={assetTableColumns} />
              )
            ) : (
              ''
            )}

            {screenMD ? (
              <TradeModal
                quickBuySecondaryOptions={quickBuySecondaryOptions}
                open={openQuickBuy}
                modalState={setOpenQuickBuy}
                quickBuyPropertyData={qucikBuyPropertyDataObject}
                isSingleTab={false}
                isSell={'1'}
                featchData={() => {
                  fetchOpenOrderTableData();
                  setOpenQuickBuy('');
                }}
              />
            ) : (
              <TradeDrawer
                quickBuySecondaryOptions={quickBuySecondaryOptions}
                open={openQuickBuy}
                modalState={setOpenQuickBuy}
                quickBuyPropertyData={qucikBuyPropertyDataObject}
                isSell={'1'}
                isSingleTab={false}
                featchData={() => {
                  fetchOpenOrderTableData();
                  setOpenQuickBuy('');
                }}
              />
            )}
          </>
        ) : (
          <></>
        )}
        {screenMD ? (
          <>
            <EditOrderModal
              selectedProperty={quickBuySecondaryOptions?.selectedProperty}
              EditOrderOne={quickBuySecondaryOptions?.openModal}
              CloseFunction={quickBuySecondaryOptions?.setOpenModal}
              propertyDetails={propertyDetails}
              properyLoading={propertyLoading}
              setOpenModal={(value) => {
                fetchOpenOrderTableData();
                quickBuySecondaryOptions?.setOpenModal(value);
              }}
            />
          </>
        ) : (
          <>
            <EditOrderDrawer
              selectedProperty={quickBuySecondaryOptions?.selectedProperty}
              EditOrderOneDrawer={quickBuySecondaryOptions?.openModal}
              CloseDrawer={quickBuySecondaryOptions?.setOpenModal}
              propertyDetails={propertyDetails}
              properyLoading={propertyLoading}
              setOpenModal={(value) => {
                fetchOpenOrderTableData();
                quickBuySecondaryOptions?.setOpenModal(value);
              }}
            />
          </>
        )}
        {screenMD ? (
          <>
            {quickBuySecondaryOptions?.openPinModal && (
              <PinModalWithoutButton
                onCancel={() => {
                  quickBuySecondaryOptions?.setOpenPinModal(false);
                }}
                open={quickBuySecondaryOptions?.openPinModal}
                pin={quickBuySecondaryOptions?.pin}
                loading={quickBuySecondaryOptions?.loading}
                handleForgotPin={quickBuySecondaryOptions?.handleForgotPin}
                setPin={quickBuySecondaryOptions?.setPin}
                setLoading={quickBuySecondaryOptions?.setLoading}
                onSuccess={(isTOSAccepted) => {
                  orderRef?.current?.resetFields();
                  quickBuySecondaryOptions?.handleVerifyPinOpenOrders(isTOSAccepted);
                }}
              />
            )}
          </>
        ) : (
          <>
            {quickBuySecondaryOptions?.openPinModal && (
              <PinDrawerWithoutButton
                onCancel={() => {
                  quickBuySecondaryOptions?.setOpenPinModal(false);
                }}
                open={quickBuySecondaryOptions?.openPinModal}
                pin={quickBuySecondaryOptions?.pin}
                loading={quickBuySecondaryOptions?.loading}
                handleForgotPin={quickBuySecondaryOptions?.handleForgotPin}
                setPin={quickBuySecondaryOptions?.setPin}
                setLoading={quickBuySecondaryOptions?.setLoading}
                onSuccess={(isTOSAccepted) => {
                  orderRef?.current?.resetFields();
                  quickBuySecondaryOptions?.handleVerifyPinOpenOrders(isTOSAccepted);
                }}
              />
            )}
          </>
        )}
        <MarketFooter />
      </div>

      {quickBuySecondaryOptions?.portfolioTOSModal && (
        <ListingAgreement
          isOpen={quickBuySecondaryOptions?.portfolioTOSModal}
          onClose={quickBuySecondaryOptions?.onPortfolioTOSClose}
          onAgreementAccept={quickBuySecondaryOptions?.onPortfolioTOSSuccess}
        />
      )}
    </>
  );
};

export default Portfolio;
